import React, { useState } from 'react'
import { useSelector } from 'react-redux'

const IMPERSONATION_KEY = 'isImpersonation'
const ADMIN_EMAIL_KEY   = 'impersonationAdminEmail'

const bannerStyle = {
    background: '#E24B4A',
    color: '#ffffff',
    fontSize: '13px',
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    zIndex: 9999,
    width: '100%',
    boxSizing: 'border-box',
    flexShrink: 0,
}

const exitButtonStyle = {
    background: 'rgba(255,255,255,0.2)',
    border: '1px solid rgba(255,255,255,0.4)',
    borderRadius: '4px',
    color: '#ffffff',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '600',
    padding: '3px 10px',
    marginLeft: '16px',
    lineHeight: '1.5',
    flexShrink: 0,
}

const ImpersonationBanner = () => {
    const [active] = useState(() =>
        sessionStorage.getItem(IMPERSONATION_KEY) === '1'
    )

    const user    = useSelector((state) => state.Auth?.profile?.user)
    const empresa = useSelector((state) => state.Auth?.profile?.empresa)

    if (!active) return null

    const adminEmail = sessionStorage.getItem(ADMIN_EMAIL_KEY) || 'Admin'

    const handleExit = () => {
        // Clear session storage impersonation keys
        sessionStorage.removeItem(IMPERSONATION_KEY)
        sessionStorage.removeItem(ADMIN_EMAIL_KEY)

        // Clear auth tokens and profile from localStorage (standard logout pattern)
        localStorage.removeItem('token')
        localStorage.removeItem('profile')

        // Redirect to login without navigating back to admin panel
        window.location.href = '/login'
    }

    return (
        <div style={bannerStyle} role="alert">
            <span>
                🔧 Sesión de soporte activa — viendo como{' '}
                <strong>{empresa?.nombre || '…'}</strong>
                {user?.email ? ` (${user.email})` : ''}
            </span>
            <button style={exitButtonStyle} onClick={handleExit}>
                ✕ Salir
            </button>
        </div>
    )
}

export default ImpersonationBanner
